(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["BT-marquee"] && !Shopify.designMode) return;
  try {
    
class KsMarquee extends HTMLElement {
  constructor () {
    super()

    this.init()

    document.addEventListener('shopify:section:load', (e) => {
      console.log(e.target) 
      if (e.target.querySelector('.ks-marquee')) {
        init()
      }
    })
  }

  init () {
    const list = this.querySelector('ul')
    console.log(list)
    const marqueeWidth = list.scrollWidth
    console.log(list.scrollWidth)
    const marqueeLength = list.querySelectorAll('li').length 

    list.insertAdjacentHTML('beforeEnd', list.innerHTML)

    list.querySelectorAll('li').forEach((item, index) => {
      if (index >= marqueeLength) {
        item.setAttribute('aria-hidden', 'true')
      }
    })

    let style = `
      <style>
        #ks-marquee-${this.dataset.sectionId} ul {
          animation-name: ks-marquee-animation-${this.dataset.sectionId};
          animation-duration: ${this.dataset.animationDuration}s;
        }
        @keyframes ks-marquee-animation-${this.dataset.sectionId} {
          to { transform: translateX(-${marqueeWidth}px); }
        }
      </style>
    `
    if (this.dataset.marqueeDirection === 'right') {
      style += `
        <style>
          @keyframes ks-marquee-animation-${this.dataset.sectionId} {
            from { transform: translateX(-${marqueeWidth}px); }    
            to { transform: 0); }    
          }
        </style>
      `
    }

    this.insertAdjacentHTML('beforeBegin', style)
  }
}
customElements.define('ks-marquee', KsMarquee)


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["BT-sticky-cart"] && !Shopify.designMode) return;
  try {
    
  class KsStickyAtc extends HTMLElement {
    constructor () {
      super()

      this.variantSelector = this.querySelector('select[name="id"]')
      this.mainVariantInput = document.querySelector('.product .product-form input[name="id"]')

      this.handleVisibility()
      this.handleVariantChange()
      this.handleMainVariantChange()
    }

    handleVisibility () {
      const top = document.querySelector('product-info product-form').getBoundingClientRect().bottom + window.scrollY

      window.addEventListener('scroll', () => {
        if (window.scrollY > top) {
          this.classList.add('show')
          document.body.style.paddingBottom = this.clientHeight + 'px'
        } else {
          this.classList.remove('show')
          document.body.style.paddingBottom = 0
        }
      })
    }

    handleVariantChange () {
      if (!this.variantSelector) return

      this.variantSelector.addEventListener('change', () => {
        const selectedOption = this.variantSelector.querySelector('option:checked')
        const variantImg = selectedOption.getAttribute('data-img')
        const variantComparePrice = selectedOption.getAttribute('data-compare-price')
        const variantPrice = selectedOption.getAttribute('data-price')

        this.querySelectorAll('img').forEach(elem => {
          elem.src = variantImg
        })
 
        this.querySelectorAll('.price').forEach(elem => {
          if (variantComparePrice.length) {
            elem.classList.add('price--on-sale')
            elem.querySelector('.price__sale .price-item--regular').textContent = variantComparePrice
            elem.querySelector('.price__sale .price-item--sale').textContent = variantPrice
          } else {
            elem.classList.remove('price--on-sale')
            elem.querySelector('.price__regular .price-item--regular').textContent = variantPrice
          }
        })

        this.querySelectorAll('button[name="add"]').forEach(btn => {
          if (selectedOption.disabled) {
            btn.disabled = true
            btn.querySelector('span').textContent = this.dataset.textSoldOut
          } else {
            btn.disabled = false
            btn.querySelector('.sold-out-message').classList.add('hidden')
            btn.querySelector('span').textContent = this.dataset.textAddToCart
          }
        })
      })
    }

    handleMainVariantChange () {
      this.mainVariantInput.addEventListener('change', (event) => {
        this.variantSelector.value = this.mainVariantInput.value
        this.variantSelector.dispatchEvent(new Event('change'))
      })
    }
  }
  customElements.define('ks-sticky-atc', KsStickyAtc)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["BT-whatsapp"] && !Shopify.designMode) return;
  try {
     
  class KsWhatsAppChat extends HTMLElement {
    constructor () {
      super ()

      this.chatButton = this.querySelector('#ks-whatsapp-chat-btn')
      this.dialog = this.querySelector('#ks-whatsapp-chat-dialog')
      this.userForm = this.querySelector('#ks-whatsapp-chat-dialog-user-form')
      this.userInput = this.querySelector('#ks-whatsapp-chat-dialog-user-input')
      this.whatsappNumber = this.dataset.whatsappNumber.split('-').join('')
      
      this.handleChatButtonClick()
      this.handelCloseDialogButtonClick()
      this.handleKeyboardIssueMobile()
      this.handleFormSubmit()
    }

    handleChatButtonClick () {
      this.chatButton.addEventListener('click', () => {
        if (this.dataset.hasDialog === 'true') {
          this.openDialog()
        } else {
          this.chatButton.classList.add('loading')
          setTimeout(() => {
            window.open(`https://wa.me/${this.whatsappNumber}`, '_blank')
            this.chatButton.classList.remove('loading')
          }, 1000)
        }
      })
    }

    openDialog () {
      if (this.dialog.hasAttribute('open')) {
        this.closeDialog()
        return
      }

      this.dialog.setAttribute('open', '')
      this.setAttribute('data-dialog-open', 'true')

      setTimeout(() => {
        this.querySelector('#ks-whatsapp-chat-dialog-user-input').focus()
      }, 3000)
    
      setTimeout(() => {
        this.querySelector('#ks-whatsapp-chat-dialog-msg-typing').style.display = 'none'
        this.querySelector('#ks-whatsapp-chat-dialog-msg-text').style.display = 'block'
      }, 2000)

      this.trapFocus()
    }

    closeDialog () {
      this.dialog.removeAttribute('open')
      this.setAttribute('data-dialog-open', 'false')
      this.chatButton.focus()
    }
    
    handelCloseDialogButtonClick () {
      this.querySelector('#ks-whatsapp-chat-dialog-close').addEventListener('click', () => {
        this.closeDialog()
      })
    }

    handleKeyboardIssueMobile () {
      this.userInput.addEventListener('focus', () => {
        this.dialog.setAttribute('data-keyboard-open', '')
      })
      this.userInput.addEventListener('blur', () => {
        this.dialog.removeAttribute('data-keyboard-open')
      })
    }

    trapFocus() {
      const focusableElements = this.dialog.querySelectorAll(
        'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
      )
      const firstElement = focusableElements[0]
      const lastElement = focusableElements[focusableElements.length - 1]

      function handleTab(event) {
        if (event.key === 'Tab') {
          if (event.shiftKey && document.activeElement === firstElement) {
            event.preventDefault()
            lastElement.focus()
          } else if (!event.shiftKey && document.activeElement === lastElement) {
            event.preventDefault()
            firstElement.focus()
          }
        }
      }

      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.closeDialog())

      this.dialog.addEventListener('keydown', handleTab)

      return () => {
        this.dialog.removeEventListener('keydown', handleTab)
      }
    }

    handleFormSubmit () {
      this.userForm.addEventListener('submit', (event) => {
        event.preventDefault()
         this.querySelector('#ks-whatsapp-chat-dialog-btn').classList.add('loading')

         setTimeout(() => {
          if (this.userInput.value) {
              const text = encodeURIComponent(this.userInput.value)
              window.open(`https://wa.me/${this.whatsappNumber}?text=${text}`, '_blank')
          } else {
            window.open(`https://wa.me/${this.whatsappNumber}`, '_blank')
          }

          this.querySelector('#ks-whatsapp-chat-dialog-btn').classList.remove('loading')
        }, 1000)
      })
    }
  }
  customElements.define('ks-whatsapp-chat', KsWhatsAppChat)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundle-builder"] && !Shopify.designMode) return;
  try {
    
  const injectElements = () => {
    const productGridPadding = document.querySelector('[class*="product-grid-padding"]')
    const bundleCard = document.querySelector('#ks-bundle-card')

    productGridPadding.querySelectorAll('.page-width').forEach(elem => {
      elem.classList.remove('page-width')
    })

    productGridPadding.classList.add('page-width')
    productGridPadding.insertAdjacentElement('afterbegin', bundleCard)
  }
  injectElements()
  
  const adjustProductForms = () => {  
    document.querySelectorAll('.collection product-form').forEach(productForm => {
      var newProductForm = document.createElement('ks-bundle-product-form')
      newProductForm.innerHTML = productForm.innerHTML

      productForm.parentNode.replaceChild(newProductForm, productForm)
    })
  }
  adjustProductForms()

  const adjustQuickViewContents = () => {
    const quickAddModal = document.querySelector('quick-add-modal')
      
      const observer = new MutationObserver((mutations) => { 
        setTimeout(() => {
          const productForm = quickAddModal.querySelector('product-form')
          if (!productForm) return

          var newProductForm = document.createElement('ks-bundle-product-form')
          newProductForm.innerHTML = productForm.innerHTML

          productForm.parentNode.replaceChild(newProductForm, productForm)
        }, 500)
      })

      observer.observe(quickAddModal, { 
        attributes: true
      });
  }
  adjustQuickViewContents()

  const reInitAfterAjaxLoad = () => {
    const wrapper = document.querySelector('.collection')

    const observer = new MutationObserver(async (mutations) => {
      setTimeout(() => {
        const productGridPadding = document.querySelector('[class*="product-grid-padding"]')
        
        productGridPadding.querySelectorAll('.page-width').forEach(elem => {
          elem.classList.remove('page-width')
        }) 
        
        adjustProductForms()
        reInitAfterAjaxLoad()
      }, 500)

    })

    observer.observe(wrapper, { 
      attributes: true,
      childList: true,
    });
  }
  reInitAfterAjaxLoad()

  class KsBundleProductForm extends HTMLElement {
    constructor () {
      super()

      setTimeout(() => {
        this.form = this.querySelector('form')
        this.btn = this.querySelector('button[name="add"]')
        this.quickAddModal = this.closest('.quick-add-modal')

        this.form.addEventListener('submit', this.onSubmit.bind(this))
        this.adjustBtn()
        this.handleVariantChange()
      }, 50)
    }

    adjustBtn () {
      if (!this.btn.disabled) {
        this.btn.querySelector('span').textContent = window.ks_bundle_builder.text.add_to_bundle
      }
    }

    handleVariantChange () {
      if (this.quickAddModal) {
        this.quickAddModal.querySelectorAll('variant-selects input').forEach(input => {
          input.addEventListener('change', () => {
            this.btn.style.opacity = '.1'

            setTimeout(() => {
              this.adjustBtn()
              this.btn.style.opacity = '1'
            }, 500)
          })
        })
      }
    }

    async onSubmit (event) {
      event.preventDefault()
         
      this.btn.classList.add('loading')
      this.btn.querySelector('.loading__spinner').classList.remove('hidden') 

      const variantId = Number(this.form.querySelector('[name="id"]').value)

      const bundleContents = JSON.parse(localStorage.getItem('ks-bundle-contents')) || []

      const isInBundleContents = bundleContents.some((item) => item.variant_id === variantId)

      let qty = 1

      if (this.quickAddModal) {
        const qtyFeield = this.quickAddModal.querySelector('input[name="quantity"]')

        if (qtyFeield) {
          qty = Number(qtyFeield.value)
        }
      }

      if (isInBundleContents) {
        bundleContents.map(item => {
          if (item.variant_id === variantId) {
            item.quantity += qty
          }
          return item
        })
      } else {
        let productLink 
      
        if (this.quickAddModal) {
          productLink = this.closest('.product').querySelector('a[href*="products"]').getAttribute('href') 
        } else {
          productLink = this.closest('.card').querySelector('a[href*="products"]').getAttribute('href') 
        }

        productLink = productLink.replace(/(\?.*)|(#.*)/g, "")

        const response = await fetch(`${productLink}.js`)
        const product = await response.json()
        console.log(product)

        const variant = product.variants.find(variant => variant.id === variantId)
        console.log(variant)

        bundleContents.push({
          product_id: product.id,
          product_handle: product.handle,
          product_title: product.title,
          product_image: product.featured_image,
          variant_id: variant.id,
          variant_title: variant.title,
          variant_price: variant.price, 
          variant_compare_at_price: variant.compare_at_price,
          variant_image: variant.featured_image ? variant.featured_image.src : null,
          quantity: qty
        })
      }

      console.log(bundleContents)

      localStorage.setItem('ks-bundle-contents', JSON.stringify(bundleContents))

      this.btn.querySelector('span').textContent = window.ks_bundle_builder.text.added_to_bundle
      this.btn.classList.remove('loading')
      this.btn.querySelector('.loading__spinner').classList.add('hidden') 
      
      window.dispatchEvent(new CustomEvent('ks_bundle_builder_add_to_bundle'))

      setTimeout(() => {
        this.quickAddModal?.hide()
      }, 1000)

      setTimeout(() => {
        this.btn.querySelector('span').textContent = window.ks_bundle_builder.text.add_to_bundle

        this.quickAddModal?.hide()
      }, 2000)
    }
  }
  customElements.define('ks-bundle-product-form', KsBundleProductForm)

  class KsBundleCard extends HTMLElement {
    constructor () {
      super ()
  
      this.updateContents()
      this.fixStickyPosition()

      window.addEventListener('ks_bundle_builder_add_to_bundle', () => {
        this.updateContents()
      })

      document.querySelectorAll('.ks-btn-atc').forEach(btn => {
        btn.addEventListener('click', () => {
          this.onAddToCart(btn)
        })
      })
    }

    getBundleContents () {
      return JSON.parse(localStorage.getItem('ks-bundle-contents')) || []
    }

    getTotalPrice () {
      return this.getBundleContents().reduce((accumulator, currentValue) =>
        (currentValue.variant_price * currentValue.quantity) + accumulator, 0)
    }

    updateContents () {
      const totalPrice = this.getTotalPrice()
      const progressBar = this.querySelector('.progress-bar') 
      const progressText = this.querySelector('.progress-text') 
      const tiers = window.ks_bundle_builder.tiers
      const maxTierGoal = window.ks_bundle_builder.max_tier_goal
      let progressWidth = Math.round(totalPrice / maxTierGoal * 100)

      if (progressWidth > 100) progressWidth = 100
      
      setTimeout(() => {
        progressBar.style.width = `${progressWidth}%`

        if (progressWidth >= 100) {
          progressBar.style.backgroundColor = progressBar.dataset.colorCompleted
        } else {
          progressBar.style.backgroundColor = progressBar.dataset.colorNotCompleted 
        }
      }, 200)

      if (totalPrice <= maxTierGoal) {
        const tier = tiers.find(elem => elem.goal > totalPrice)
        const remaining = this.formatMoney(tier.goal - totalPrice).replace('.00', '')
        const discount = tier.discount + '%' 
        let textUncompleted = progressText.dataset.textUncompleted
        textUncompleted = textUncompleted.replace('[value]', `<b>${remaining}</b>`)
        textUncompleted = textUncompleted.replace('[discount]', `<b>${discount}</b>`)
        progressText.innerHTML = textUncompleted
        progressText.style.color = ''
      } else {
        const discount = tiers[tiers.length - 1].discount + '%'

        let textCompleted = progressText.dataset.textCompleted
        textCompleted = textCompleted.replace('[discount]', `<b>${discount}</b>`)
        progressText.innerHTML = textCompleted
        progressText.style.color = progressBar.dataset.colorCompleted
      }

      document.querySelectorAll('[data-ks-bundle-price]').forEach(elem => {
        const tier = tiers.slice().reverse().find(elem => elem.goal <= totalPrice)

        if (tier) {
          const compareAtPrice = this.formatMoney(totalPrice)
          const price = this.formatMoney((1 - (tier.discount / 100)) * totalPrice)
          elem.innerHTML = `
            <span class="visually-hidden visually-hidden--inline">Regular price</span>
            <s>${compareAtPrice}</s> 
            <span class="visually-hidden visually-hidden--inline">Sale price</span>
            <b>${price}</b>
          `
        } else {
          elem.innerHTML = this.formatMoney(totalPrice)
        }
      })

      document.querySelectorAll('[data-ks-bundle-discount]').forEach(elem => {
        const tier = tiers.slice().reverse().find(elem => elem.goal <= totalPrice)

        const tierDiscount = tier?.discount || 0

        const savings = this.formatMoney(tierDiscount / 100 * totalPrice)
        elem.innerHTML = `${savings} (${tierDiscount}%)`
      }) 

      document.querySelectorAll('.ks-btn-view-contents').forEach(elem => {
        elem.disabled = totalPrice === 0
      })

      document.querySelectorAll('.ks-btn-atc').forEach(elem => {
        elem.disabled = totalPrice === 0
      })
    } 

    async onAddToCart (btn) {
      btn.classList.add('loading')
      btn.querySelector('.loading__spinner').classList.remove('hidden') 

      const items = this.getBundleContents().reduce((accumulator, currentValue) => {
        accumulator.push({
          id: currentValue.variant_id,
          quantity: currentValue.quantity
        })
        return accumulator
      }, []) 

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer')
      let sections = cart.getSectionsToRender().map((section) => section.id)

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items, sections })
      })
      const responseData = await response.json()

      localStorage.removeItem('ks-bundle-contents')
      this.updateContents()

      if (btn.dataset.redirectToCheckout === 'true') {
        window.location.href = '/checkout'
        return
      }

      btn.classList.remove('loading')
      btn.querySelector('.loading__spinner').classList.add('hidden')
      
      document.querySelector('#ks-bundle-dialog')?.close()
      
      cart.renderContents(responseData)
      if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty')
    }

    fixStickyPosition () {
      const elem = this.querySelector('.ks-inner-content')
      let oldScroll = window.scrollY

      window.addEventListener('scroll', (event) => {
        if (!document.querySelector('.shopify-section-header-sticky')) return
  
        const newScroll = window.scrollY

        if (newScroll > oldScroll) {
          elem.style.top = '1.5rem'
        } else if (newScroll < oldScroll) {
          elem.style.top = 'calc(var(--header-height) + 1.5rem)'
        }

        oldScroll = Math.max(window.scrollY, 0)
      })
    }

    formatMoney (cents, moneyFormat = this.dataset.moneyFormat) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '')
      }

      let value = ''
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/

      function defaultOption (opt, def) {
        return (typeof opt === 'undefined' ? def : opt)
      }

      function formatWithDelimiters (number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2)
        thousands = defaultOption(thousands, ',')
        decimal = defaultOption(decimal, '.')

        if (isNaN(number) || number == null) {
          return 0
        }

        number = (number / 100.0).toFixed(precision)

        const parts = number.split('.')
        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands)
        const cents = parts[1] ? (decimal + parts[1]) : ''

        return dollars + cents
      }

      switch (moneyFormat.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2)
        break
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0)
        break
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',')
        break
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',')
        break
      }

      return moneyFormat.replace(placeholderRegex, value)
    }
  }
  customElements.define('ks-bundle-card', KsBundleCard)

  class KsBundleStickyCard extends HTMLElement {
    constructor () {
      super()

      const bundleCard = document.querySelector('#ks-bundle-card')

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.classList.remove('show')
          } else {
            this.classList.add('show')
          }
        })
      }, { threshold: 0 })

      observer.observe(bundleCard)
    }
  }
  customElements.define('ks-bundle-sticky-card', KsBundleStickyCard)

  class KsBundleDialog extends HTMLElement {
    constructor () {
      super()

      this.dialog = this.querySelector('dialog')

      document.querySelectorAll('.ks-btn-view-contents').forEach(btn => {
        btn.addEventListener('click', () => {
          this.dialog.showModal()
          document.querySelector('body').classList.add('overflow-hidden')
        })
      })

      // Close dialog if clicked outside
      this.dialog.addEventListener('click', (event) => {
        const withinBoundaries = event.composedPath().includes(this.dialog.querySelector('.ks-dialog-inner'))

        if (!withinBoundaries) {
          this.dialog.close()
        }
      })

      this.dialog.querySelector('data-dialog-close')?.addEventListener('click', (event) => {
        event.preventDefault()
        this.dialog.close()
      })

      this.dialog.addEventListener('close', (event) => {
        document.querySelector('body').classList.remove('overflow-hidden')
      })

      this.buildContents()

      window.addEventListener('ks_bundle_builder_add_to_bundle', () => {
        this.buildContents()
      })
    }

    getBundleContents () {
      return JSON.parse(localStorage.getItem('ks-bundle-contents')) || []
    }

    buildContents () {
      const wrapper = this.querySelector('.ks-bundle-contents')
      wrapper.innerHTML = ''

      let bundleContentsList = ''

      this.getBundleContents().forEach(elem => {
        const image = elem.variant_image || elem.product_image
      
        bundleContentsList += `
          <div class="ks-bundle-contents-item" role="listitem">
            <div class="ks-bundle-contents-item-left">
              <img 
                src="${this.resizeImage(image, `600x600`, 'center')}"
                class="" 
                alt="" 
                width="600" 
                height="600" 
                loading="lazy">
            </div>
            <div class="ks-bundle-contents-item-right">
              <h3 class="title h4">
                ${elem.product_title}
              </h3>
              <p class="ks-variant-title product-option" ${elem.variant_title === 'Default Title' ? 'hidden': ''}>
                ${elem.variant_title}
              </p>
              <p class="ks-variant-price product-option">
                ${document.querySelector('#ks-bundle-card').formatMoney(elem.variant_price)}
              </p>
              <div class="ks-quantity-wrapper">
                <quantity-input class="quantity">
                  <button class="quantity__button no-js-hidden disabled" name="minus" type="button">
                    <span class="visually-hidden">Decrease quantity</span>
                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path>
                    </svg>
                  </button>
                  <input 
                    class="quantity__input" 
                    type="number"
                    value="${elem.quantity}" 
                    min="1" 
                    step="1" 
                    aria-label="Quantity"
                    data-variant-id="${elem.variant_id}"
                    onchange="document.querySelector('ks-bundle-dialog').updateItemQty(this, event)">
                  <button class="quantity__button no-js-hidden" name="plus" type="button">
                    <span class="visually-hidden">Increase quantity</span>
                    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor">
                      </path>
                    </svg>
                  </button>
                </quantity-input>
                <button
                  type="button" 
                  class="button button--tertiary ks-remove-btn" 
                  aria-label="Remove" 
                  data-variant-id="${elem.variant_id}"
                  onclick="document.querySelector('ks-bundle-dialog').removeItem(this, event)">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false" class="icon icon-remove">
                    <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
                    <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        ` 
      })

      wrapper.insertAdjacentHTML('afterbegin', bundleContentsList)
    }

    updateItemQty (input, event) {
      const variantId = Number(input.dataset.variantId)
      const newQty = Number(input.value)

      let bundleContents = this.getBundleContents()

      bundleContents.map(item => {
        if (item.variant_id === variantId) {
          item.quantity = newQty
        }
        return item
      })

      localStorage.setItem('ks-bundle-contents', JSON.stringify(bundleContents))
    
      this.buildContents()
      document.querySelector('#ks-bundle-card').updateContents()
    }

    removeItem (btn, event) {
      const variantId = Number(btn.dataset.variantId)

      let bundleContents = this.getBundleContents()

      bundleContents = bundleContents.filter(item => item.variant_id !== variantId)

      localStorage.setItem('ks-bundle-contents', JSON.stringify(bundleContents))
    
      this.buildContents()
      document.querySelector('#ks-bundle-card').updateContents()

      if (!bundleContents.length) {
        this.dialog.close()
      }
    }

    resizeImage = function (src, size, crop = '') {
      return src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
        .replace(/\.jpg|\.png|\.gif|\.jpeg/g, (match) => {
          if (crop.length) {
            crop = `_crop_${crop}`
          }
          return `_${size}${crop}${match}`
        })
    }
  }
  customElements.define('ks-bundle-dialog', KsBundleDialog)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
